// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import SortButton from './SortButton';
import AlertsButton from './AlertsButton';

// Hooks
import { useListingHeader } from './hooks';

// Misc / utils
import * as S from './styles';

const areEqual = (prevProps, nextProps) => {
  if (
    prevProps.totalListings === nextProps.totalListings &&
    prevProps.searchSlug === nextProps.searchSlug &&
    prevProps.totalBuildings === nextProps.totalBuildings &&
    prevProps.currentPage === nextProps.currentPage
  ) {
    return true;
  }

  return false;
};

const ListingHeader = ({
  className,
  searchSlug,
  slugTitle,
  totalBuildings,
  totalListings,
  currentPage,
  propertyType,
  isDesktop = false,
}) => {
  // Redux
  const areaType = useSelector((state) => state.area.area.type);
  const areaName = useSelector((state) => state.area.area.name);
  const areaFullName = useSelector((state) => state.area.area.fullName);
  const areaCity = useSelector((state) => state.area.area.city);
  const areaState = useSelector((state) => state.area.area.state);
  const areaResourceId = useSelector((state) => state.area.area.id);
  /**
   * border param is undefined (not present in query) - map has an active border
   * border=false - map does not have an active border
   */
  const hasMapBorder = useSelector((state) => state.location.current.query.border === undefined);
  const areListingsLoading = useSelector((state) => !state.app.fetchListingsByCoordsComplete);
  const isClientSideLoadedPage = useSelector((state) => state.app.isClientSideLoadedPage);

  // Hooks
  const [getScreenReaderHeader, getAreaTitle, getMainPagingText, getSecondaryPagingText] = useListingHeader();
  const screenReaderHeaderText = getScreenReaderHeader({ areaName, searchSlug, totalListings });
  const mainPagingText = getMainPagingText({ currentPage, totalBuildings, searchSlug });
  const secondaryPagingText = getSecondaryPagingText({ totalListings, slugTitle });
  const areaTitleText = getAreaTitle({
    areaType,
    areaName,
    areaFullName,
    areaCity,
    areaState,
    hasMapBorder,
    slugTitle,
  });

  const areaIsLoading = isClientSideLoadedPage ? !areaResourceId : false;

  const isAreaLoading = (areaIsLoading || areListingsLoading) && isClientSideLoadedPage;
  return (
    <>
      <S.Header className={className}>
        <S.ScreenReaderOnly as="p" role="status" aria-live="polite">
          {screenReaderHeaderText}
        </S.ScreenReaderOnly>
        <S.MasterTitle id="area-title">{`${isAreaLoading ? 'Loading...' : areaTitleText}`}</S.MasterTitle>
        {mainPagingText && secondaryPagingText && (
          <S.MainPagingText>
            {areListingsLoading ? (
              'Loading...'
            ) : (
              <>
                {mainPagingText}
                <S.SecondaryPagingText>{secondaryPagingText}</S.SecondaryPagingText>
              </>
            )}
          </S.MainPagingText>
        )}
        <S.ButtonSection>
          <S.ButtonGroup>
            <SortButton />
            {!isDesktop && <AlertsButton />}
          </S.ButtonGroup>
        </S.ButtonSection>
      </S.Header>
      <S.ScreenReaderOnly>{propertyType}</S.ScreenReaderOnly>
    </>
  );
};

export default React.memo(ListingHeader, areEqual);
